import { type ComponentProps, forwardRef } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import { Card } from '@cocoonspace/ui/components/card'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@cocoonspace/ui/components/tooltip'
import { cn } from '@cocoonspace/ui/lib/utils'

export const ScheduleCard = ({
	className,
	...props
}: ComponentProps<typeof Card>) => (
	<Card
		{...props}
		className={cn('flex flex-col gap-2 p-4', className)}
	/>
)

export const ScheduleCardHeader = ({
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex items-center gap-4', className)}
	/>
)

export const ScheduleCardTitle = ({
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex-1 truncate font-bold', className)}
	/>
)

export const ScheduleCardActions = ({
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex items-center gap-2', className)}
	/>
)

export const ScheduleCardActionBtn = forwardRef<
	HTMLButtonElement,
	ComponentProps<typeof Button> & { title: string }
>(({ className, title, ...props }, ref) => (
	<Tooltip>
		<TooltipTrigger asChild>
			<Button
				{...props}
				ref={ref}
				icon
				className={cn('!size-8', className)}
				variant='ghost'
			/>
		</TooltipTrigger>

		<TooltipContent>{title}</TooltipContent>
	</Tooltip>
))

export const ScheduleCardDescription = ({
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn(
			'text-muted-foreground flex flex-1 flex-col gap-2 text-sm',
			className,
		)}
	/>
)
